const mapSettings = {
  clickableIcons: false,
  streetViewControl: true,
  panControlOptions: false,
  gestureHandling: 'cooperative',
  mapTypeControl: false,
  zoomControlOptions: {
    style: 'SMALL',
  },
  zoom: 13,
  minZoom: 2,
  maxZoom: 20,
};

export { mapSettings };
